document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  //const header = document.querySelector(".home .site-header");
  //const headerInner = document.querySelector(".home .site-header__inner");
  const toggleBtn = document.querySelector(".button-toggle-menu");
  const closeBtn = document.querySelector(".button-close-menu");
  const overlay = document.querySelector(".overlay");

  toggleBtn?.addEventListener("click", () =>
    body.classList.toggle("menu-opened")
  );

  closeBtn?.addEventListener("click", () =>
    body.classList.remove("menu-opened")
  );

  overlay?.addEventListener("click", () =>
    body.classList.remove("menu-opened")
  );

  // close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      body.classList.remove("menu-opened");
    }
  });

  /* if (header) {
    const onScroll = debounce(() => {
      requestAnimationFrame(() => {
        header.classList.toggle("sticky", window.scrollY > 0);
      });
    }, 100);

    onScroll();

    window.addEventListener("scroll", onScroll, { passive: true });
  } */

  /* function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  } */

  function smoothScroll(target, duration = 1000) {
    const targetPosition = target.getBoundingClientRect().top;
    const startPosition = window.pageYOffset;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      // Easing function for smoother movement
      const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

      window.scrollTo(
        0,
        startPosition + targetPosition * easeInOutQuad(progress)
      );

      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  // Add click handlers to all internal links
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href");
      if (targetId === "#") return;

      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        smoothScroll(targetElement, 1000); // 1 seconds duration
      }
    });
  });
});

const header = document.querySelector(".site-header");
const doc = document.documentElement;
const threshold = 200;
let prevScroll =
  window.scrollY || doc.scrollTop || document.body.scrollTop || 0;
let curScroll = 0;
let curDirection = 0;
let ticking = false;

const checkScroll = () => {
  curScroll = window.scrollY || doc.scrollTop || document.body.scrollTop || 0;

  if (Number.isNaN(curScroll) || Number.isNaN(prevScroll)) return;

  curDirection = curScroll > prevScroll ? 2 : 1;

  if (curDirection === 2 && curScroll > threshold) {
    header.classList.add("hide");
  } else if (curDirection === 1) {
    header.classList.remove("hide");
  }

  if (curScroll > 0) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }

  prevScroll = curScroll;
  ticking = false;
};

const onScroll = () => {
  if (!ticking) {
    window.requestAnimationFrame(checkScroll);
    ticking = true;
  }
};

window.addEventListener("scroll", onScroll);
window.addEventListener("load", checkScroll);
